import { useEffect, useMemo } from "react";

import axios, { type InternalAxiosRequestConfig } from "axios";

import { useAuthContext } from "../contexts/auth";

import { API_BASE_URL } from "~/common/configs/environment.config";

/**
 * API Common Hooks
 */
export const useApi = () => {
  /** useAuth */
  const auth = useAuthContext();

  /** api */
  const api = useMemo(
    () =>
      axios.create({
        baseURL: API_BASE_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth.token}`,
        },
      }),
    [auth.token]
  );

  /**
   ** Effect - Request Interceptors
   */
  useEffect(() => {
    const requestInterceptor = api.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        if (auth.token) {
          config.headers.Authorization = `Bearer ${auth.token}`;
        }
        return config;
      }
    );

    return () => {
      api.interceptors.request.eject(requestInterceptor);
    };
  }, [api, auth.token]);

  return useMemo(() => ({ api }), [api]);
};
